const gl = {
    "project.global.fields.email": "Email",
    "project.global.fields.password": "Contrasinal",
    'project.app.Header.quiz': 'Quiz',
    'project.global.fields.points': 'Puntos',
    'project.app.Header.Awards': 'Recompensas',
    'project.users.MyAwards.title': 'As miñas Recompensas',
    'project.entities.AwardDetails.Points': 'Puntos requeridos: ',
    'project.entities.AwardDetails.Button': 'Escoller Premio',
    'project.app.Header.historic': 'Historico',
    'project.modules.historic.podiums': 'Podios',
    'project.entities.PodiumDetails.date':'Data',
    'project.entities.PodiumDetails.winner': 'Gañador',
    'project.entities.PodiumDetails.TeamWinner':'Equipo gañador',
    'project.entities.PodiumDetails.second': 'Segundo Posto',
    'project.entities.PodiumDetails.third':'Tercer Posto',
    'project.entities.Circuits': 'Circuitos F1',
    'project.entities.Podiums': 'Podios',
    'project.events.events': 'Eventos',
    'project.events.events.create': 'Crear Evento',
    'project.common.notifications.button': 'Notificacións',
    'project.users.SignUp.fields.confirmPassword': 'Confirmar Contrasinal',
    'project.global.fields.event.name': 'Nome Evento',
    'project.global.fields.event.description': 'Descrición',
    'project.global.fields.events.location' : 'Localización',
    'project.global.fields.events.date' : 'Data Evento',
    'project.global.buttons.save': 'Gardar',
    'project.global.buttons.UpdateProfile': 'Actualizar Perfil',
    'project.global.buttons.back': 'Anterior',
    'project.global.buttons.continue': 'Continuar',
    'project.global.buttons.filter': 'Filtrar',
    'project.global.buttons.next': 'Seguinte',
    'project.users.SignUp.title': 'Rexistrarse',
    'project.global.fields.firstName': 'Nome',
    'project.global.fields.lastName': 'Apelido',
    'project.users.ChangePassword.fields.confirmNewPassword': 'Confirmar novo contrasinal',
    'project.users.ChangePassword.fields.newPassword': 'Novo Contrasinal',
    'project.users.ChangePassword.fields.oldPassword': 'Antigo Contrasinal',
    'project.users.ChangePassword.title': 'Cambiar contrasinal',
    'project.users.UpdateProfileImage.title':'Engadir Imaxe',
    'project.user.userImage.title': 'Engadir imaxe de usuario',
    'project.global.fields.title': 'Titulo',
    'project.global.fields.url': 'URL',
    'project.global.fields.userName': 'Nome',
    'project.users.Profile.title': 'Titulo',
    'project.users.CreatePost.title': 'Crear Publicación',
    'project.users.MyPosts.title': 'As miñas Publicacións',
    'project.app.Header.calendar': 'Calendario',
    'project.app.Header.login': 'Iniciar Sesión',
    'project.app.Header.logout': 'Sair',
    'project.Footer': 'Overcut',
    'project.entities.EventDetails.name': 'Evento',
    'project.entities.EventDetails.description': 'Descrición',
    'project.entities.EventDetails.location': 'Localización',
    'project.entities.EventDetails.date': 'Data',
    'project.entities.EventDetails.image':'Imaxe',
    'project.entities.EventDetails.button': 'Create Notificación',
    'project.entities.Events': 'Eventos',
    'project.global.dropdown.sortOrderDES': 'Orde desc',
    'project.global.dropdown.sortOrderDefault': 'Orde por Defecto',
    'project.global.dropdown.sortOrderASC': 'Orde asc',
    'project.global.dropdown.allCategories': 'Todas as categorías',
    'project.global.dropdown.sortCriteriaAll': 'Todos',
    'project.global.dropdown.sortCriteriaCreationDate': 'Data creación',
    'project.users.CreateEvent.title': 'Crear Evento',
    'project.About_Us': 'About Us',
    'project.Contact': 'Contact',
    'project.modules.historic.stats': 'Estatísticas',
    'project.global.fields.subtitle': 'Subtitulo',
    'project.global.fields.article': 'Artículo',
    'project.global.fields.category': 'Categoría',
    'project.posts.CreatePost.title': 'Crear publicación',
    'project.entities.User.Points': 'Puntos usuario: ',
    'project.entities.Quiz.Answers': 'A resposta correcta é: ',
    'project.entities.stats.circuit': 'Datos das ultimas 10 temporadas',
    'project.entities.stats.teams.wins': 'Total de victorias de equipos nas ultimas 10 temporadas',
    'project.entities.stats.drivers.podiums': 'Pilotos con mais podios en F1',
    'project.entities.stats.drivers.wins': 'Pilotos con mais victorias en F1',
    'project.entities.stats.drivers.championships': 'Pilotos con mais campeonatos de F1',
    'project.entities.EventDetails.button.delete': 'Borrar Evento',
    'project.entities.SignUp.Journalist': 'Son periodista',
    'project.no_awards': 'Non hai recompensas disponibles',
    'project.entities.Awards.User.Points': 'Non ten os puntos suficientes',
    'project.global.post.modifyPost': 'Modificar Post',
    'project.global.fields.modifytitle': 'Titulo',
    'project.global.fields.modifysubtitle': 'Subtitulo',
    'project.global.fields.modifyarticle': 'Articulo',
    'project.global.fields.modifycategory': 'Categoria',
    'project.entities.Post.Modify': 'Modificar Post',
    'project.entities.Post.Delete': 'Borrar Post',
    'project.entities.Posts.MyPosts': 'Os meus Posts',
    'project.entities.Quiz.getPoints': 'Obtuviches ',
    'project.points': 'puntos',
    'project.YourPoints': 'Os teus puntos',
    'project.Circuit.Details.Name': 'Circuito: ',
    'project.Circuit.Details.Distance': 'Distancia: ',
    'project.Circuit.Details.Laps': 'Voltas: ',
    'project.Circuit.Details.Image': 'Imaxe: ',
    'project.Circuit.Details.Team': 'Equipo máis exitoso: ',
    'project.entities.Quiz.Result.Points': 'Puntuación dispoñíbel: ',
    'project.entities.Quiz.Result.QuizPoints': 'Puntos conseguidos: ',
    'project.entities.Quiz.Result.Questions': 'Total preguntas: ',
    'project.entities.Quiz.Result.ButtonHome': 'Volver ao inicio',
    'project.entities.Quiz.Result.Excellent': 'Excelente! Conseguiches máis da metade de puntos',
    'project.entities.Quiz.Result.Retry': 'Inténtao mellor a próxima vez',
    'project.entities.Quiz.Result': 'Resultados',
    'project.entities.Award.Result.Achieved': 'Parabéns! Conseguiches a recompensa!',
    'project.entities.Award.Result.ButtonHome': 'Ir á miña lista de recompensas',

}
export default gl;